// NOTE: this is duplicate (but needed) code, s. accessibility.js

export function waitForElm(selector) {
  return new Promise((resolve) => {
    if (window.document.querySelector(selector)) {
      return resolve(window.document.querySelector(selector));
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(window.document.querySelector(selector));
      }
    });
    observer.observe(window.document.body, {
      childList: true,
      subtree: true,
    });
  });
}

export function waitForPrivacyForm() {
  waitForElm('#ppms_cm_data_subject_form_select_wrapper select').then(() => {
    modifyPrivacyForm();
  });
}

let savedElement;
export function modifyPrivacyForm() {
  const select = window.document.querySelector(
    '#ppms_cm_data_subject_form_select_wrapper select'
  );
  if (select?.outerHTML) {
    select.setAttribute('hidden', 'false');
    select.setAttribute('aria-hidden', 'false');
    select.setAttribute('style', 'display: block !important');
    select.setAttribute('class', 'modified');
    select.setAttribute(
      'aria-labelledby',
      'ppms_cm_data_subject_form_label_request_type'
    );
    savedElement = select;
  } else if (savedElement) {
    waitForElm('#ppms_cm_data_subject_form_select_wrapper').then(() => {
      const parent = window.document.querySelector(
        '#ppms_cm_data_subject_form_select_wrapper'
      );
      if (parent?.innerHTML) {
        parent.appendChild(savedElement);
      }
    });
  }
}
